import React, {useContext, useState} from 'react';
import {useForm} from "react-hook-form";
import {LoginContext} from "../../context/login.context";
import {formatResetPasswordBody, submitForm} from "../../utils/helpers/submitForm";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import {LogoContainer} from "../../components/Logo/LogoContainer";
import { environmentVariables } from '../../utils/helpers/environmentVariables';
import {getServerRefusal, PASSWORD_PATTERN, PASSWORD_RULE_MESSAGE, RESET_FAILURE_MESSAGE} from '../../utils/helpers/passwordPolicy';

const ResetPassword = () => {
  const {register, handleSubmit, formState: {errors}, watch} = useForm({mode: 'onBlur'});
  const {user} = useContext(LoginContext)
  const navigate = useNavigate()
  // The reason the server gave for refusing the new password, shown next to the field.
  const [passwordRefusal, setPasswordRefusal] = useState(null)

  const resetPasswordSubmit = async (submitData) => {
    const loadingToast = toast.loading('Please wait...')
    setPasswordRefusal(null)
    try {
      const formattedBody = await formatResetPasswordBody(submitData, user)
      const resetPasswordResponse = await submitForm(formattedBody, environmentVariables.resetPasswordUrl())
      toast.dismiss(loadingToast)
      if (resetPasswordResponse.status === 'success' && resetPasswordResponse.status !== 'error') {
        const sendNotificationBody = {
          Parameters: [
            {
              Value: formattedBody.UserName,
              Key: "userDisplayName"
            }],
          EmailTemplate: "InsightsPasswordResetSuccess",
          Recipient: formattedBody.UserName
        };
        await submitForm(sendNotificationBody, environmentVariables.sendNotification());
        toast.success('Your password has been reset. Please log in.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000
        })
        navigate('/login')
      } else {
        // Show the server's reason: next to the field when it is about the password, otherwise as
        // a message. Only an unrecognised response gets the general one.
        const refusal = getServerRefusal(resetPasswordResponse, 'newPassword')
        if (refusal && refusal.onPasswordField) {
          setPasswordRefusal(refusal.message)
        } else {
          toast.error(refusal ? refusal.message : RESET_FAILURE_MESSAGE)
        }
      }

    } catch (error) {
      toast.error('There has been a problem resetting your password.')
    }
  }

  const checkPasswordsEqual = (val) => {
    if (watch('newPassword') !== val) return 'Passwords must match'
  }

  return (
    <div className='insightsBackgroundContainer'>
      <LogoContainer/>
      <h1 className='insightsForm__title'>Reset Password</h1>
      <form className='insightsForm' onSubmit={handleSubmit(resetPasswordSubmit)}>
        <label className='insightsForm__label' htmlFor='newPassword'>New Password</label>
        <input className={`insightsForm__input ${errors.newPassword ? 'insightsForm__input--error' : ''} `}
               type='password' {...register('newPassword', {
          required: true,
          pattern: PASSWORD_PATTERN,
          onChange: () => setPasswordRefusal(null)
        })}/>
        {errors.newPassword && errors.newPassword.type === 'required' &&
          <p className='insightsForm__error'>This field is required</p>}
        {errors.newPassword && errors.newPassword.type === 'pattern' &&
          <p className='insightsForm__error'>{PASSWORD_RULE_MESSAGE}</p>}
        {passwordRefusal && !errors.newPassword &&
          <p className='insightsForm__error'>{passwordRefusal}</p>}
        <label className='insightsForm__label' htmlFor='repeatPassword'>Repeat New Password</label>
        <input className={`insightsForm__input ${errors.newPassword ? 'insightsForm__input--error' : ''} `}
               type='password' {...register('repeatPassword', {required: true, validate: checkPasswordsEqual})}/>
        {errors.repeatPassword && errors.repeatPassword.type === 'required' &&
          <p className='insightsForm__error'>This field is required</p>}
        {errors.repeatPassword && errors.repeatPassword.type === 'validate' &&
          <p className='insightsForm__error'>{errors.repeatPassword.message}</p>}
        <button
          className={`insightsForm__submit ${
            Object.keys(errors).length > 0
              ? "insightsForm__submit--disabled"
              : ""
          }`}
          onClick={handleSubmit(resetPasswordSubmit)}
          type="submit"
          disabled={Object.keys(errors).length > 0}
        >
          <p className="insightsForm__email">Continue</p>
          <img
            className="insightsForm__icon"
            src={
              Object.keys(errors).length > 0
                ? "/Sign_in_circle_disabled.svg"
                : "/Sign_in_circle_enabled.svg"
            }
            alt=""
          />
        </button>
      </form>
    </div>
  );
};

export default ResetPassword;